import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';

import lottieData from '../../assets/backgroundLottie.json';

import { Background } from './BackgroundAnim.styles';

const BackgroundAnim = () => {
  const backgroundEl = useRef(null);
  useEffect(() => {
    lottie.loadAnimation({
      container: backgroundEl.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: lottieData,
      rendererSettings: {
        preserveAspectRatio: 'xMaxYMin slice',
      },
    });
  }, []);

  return <Background ref={backgroundEl} />;
};

export default BackgroundAnim;
